(() => {
  'use strict';
  if (window.cpDeliveryEstimateReady) return;
  window.cpDeliveryEstimateReady = true;
  const selector = '[data-cp-delivery-estimate]';
  const calendar = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Europe/Berlin', year: 'numeric', month: '2-digit', day: '2-digit'
  });

  function deliveryDate(now) {
    const parts = Object.fromEntries(calendar.formatToParts(now).map(part => [part.type, part.value]));
    const day = new Date(Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day), 12));
    let remaining = 2;
    while (remaining > 0) {
      day.setUTCDate(day.getUTCDate() + 1);
      if (day.getUTCDay() !== 0 && day.getUTCDay() !== 6) remaining -= 1;
    }
    return day;
  }

  function update(element, now = new Date()) {
    const date = deliveryDate(now);
    const key = date.toISOString().slice(0, 10);
    if (element.dataset.deliveryDate === key) return;
    let formatter;
    try {
      formatter = new Intl.DateTimeFormat(element.dataset.locale || 'de-DE', { weekday: 'long', timeZone: 'UTC' });
    } catch (_) {
      formatter = new Intl.DateTimeFormat('de-DE', { weekday: 'long', timeZone: 'UTC' });
    }
    const weekday = formatter.format(date);
    const template = element.dataset.deliveryTemplate;
    if (!template || !template.includes('__weekday__')) return;
    element.textContent = template.replace('__weekday__', weekday);
    element.dataset.deliveryDate = key;
  }

  function refresh(root = document) {
    if (root.matches?.(selector)) update(root);
    root.querySelectorAll?.(selector).forEach(element => update(element));
  }

  refresh();
  const root = document.querySelector('#MainContent');
  if (root) new MutationObserver(records => {
    for (const record of records) {
      for (const node of record.addedNodes) if (node.nodeType === 1) refresh(node);
    }
  }).observe(root, { childList: true, subtree: true });
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) refresh();
  });
  window.addEventListener('pageshow', () => refresh());
  window.setInterval(() => {
    if (!document.hidden) refresh();
  }, 60000);
})();
